var _ellipse, _path, _path2, _ellipse2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInexploreTvLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 81,
    height: 81,
    viewBox: "0 0 81 81",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 40.2782,
    cy: 40.3955,
    rx: 40.1806,
    ry: 40,
    fill: "url(#paint0_linear_7321_20265)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.62109 40.3953C8.62109 23.0164 22.8214 8.87988 40.2788 8.87988C57.7361 8.87988 71.9364 23.0164 71.9364 40.3953C71.9364 57.7742 57.7361 71.9107 40.2788 71.9107C22.8214 71.9107 8.62109 57.7742 8.62109 40.3953ZM11.9245 40.3953C11.9245 55.959 24.6448 68.6221 40.2788 68.6221C55.9127 68.6221 68.633 55.959 68.633 40.3953C68.633 24.8316 55.9127 12.1684 40.2788 12.1684C24.6448 12.1684 11.9245 24.8316 11.9245 40.3953Z",
    fill: "url(#paint1_linear_7321_20265)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.2773 40.3958C20.2773 29.4177 29.25 20.4854 40.2777 20.4854C51.3054 20.4854 60.278 29.4177 60.278 40.3958C60.278 51.374 51.3054 60.3063 40.2777 60.3063C29.25 60.3063 20.2773 51.374 20.2773 40.3958ZM23.5808 40.3958C23.5808 49.5615 31.0707 57.0177 40.2777 57.0177C49.4847 57.0177 56.9746 49.5615 56.9746 40.3958C56.9746 31.2302 49.4847 23.7739 40.2777 23.7739C31.0707 23.7739 23.5808 31.2302 23.5808 40.3958Z",
    fill: "url(#paint2_linear_7321_20265)"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 40.2787,
    cy: 40.3952,
    rx: 7.55805,
    ry: 7.52408,
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_7321_20265",
    x1: 36.0795,
    y1: 93.8442,
    x2: 80.1814,
    y2: 45.0316,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#74C4EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#6FC2ED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#61BCEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#4BB2E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#38AAE1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#3195CD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#20619C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#20619C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#454A96"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#613A91"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6C3490"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_7321_20265",
    x1: 31.6455,
    y1: -10.7525,
    x2: -8.80055,
    y2: 48.7768,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#74C4EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#6FC2ED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#61BCEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#4BB2E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#38AAE1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#3195CD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#20619C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#20619C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#454A96"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#613A91"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6C3490"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_7321_20265",
    x1: 11.0853,
    y1: 38.9062,
    x2: 38.3626,
    y2: 72.3166,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#74C4EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#6FC2ED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#61BCEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#4BB2E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#38AAE1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#3195CD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#20619C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#20619C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#454A96"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#613A91"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6C3490"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInexploreTvLogo);
export default __webpack_public_path__ + "static/media/inexploreTvLogo.d2cfce9280bace0fce389e6812659f65.svg";
export { ForwardRef as ReactComponent };